import Delete from "@mui/icons-material/Delete";
import { Button, IconButton, Stack, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useCart, useCartLine } from "@shopify/hydrogen-react";
import { CurrencyCode, MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";
import { useCartStyling } from ".";
import { useAutomaticDiscountList } from "../../shared/hooks/useAutomaticDiscountList";
import useLoggedInCustomer from "../../shared/hooks/useLoggedInCustomer";
import { NumericInput } from "../controls/numeric-input";
import { indexOfFirstProductImageForCart } from "../products/constants";
import { MoneyDisplay } from "./moneyDisplay";

import { Link } from "gatsby";


type CartLineItemProps = {
    isCartLoading: boolean;
}


export function CartLineItem({ isCartLoading }: CartLineItemProps) {
    const theme = useTheme();
    const styles = useCartStyling(theme)
    const item = useCartLine();
    const { linesUpdate, linesRemove, totalQuantity } = useCart();

    const loggedInCustomer = useLoggedInCustomer();

    const handleRemove = () => {
        linesRemove([item.id])
    }

    const handleQuantityChange = (value: number) => {
        if (Number(value) < 0) {
            return
        }

        const numberVal = Number(value);

        if (numberVal >= 1) {

            linesUpdate([
                {
                    id: item.id,
                    merchandiseId: item.merchandise.id,
                    quantity: numberVal
                }
            ])
        }
        else if (numberVal === 0) {
            linesRemove([item.id])
        }
    }

    const allLoading = false;

    const productRoute = `/products/${item.merchandise.product.handle}`

    // if (isCartLoading) return <Skeleton />

    const discounts = useAutomaticDiscountList();
    // const discountedPriceSingle = discounts.discountPriceForPrice(1, item.cost.amountPerQuantity as MoneyV2);

    // console.log('heree item', item)

    let discountedUnitPrice: MoneyV2;
    let discountedTotal: MoneyV2;
    let nonDiscountTotal: MoneyV2 = {
        currencyCode: item.cost.subtotalAmount.currencyCode as CurrencyCode,
        amount: item.cost.subtotalAmount.amount as string,
    };
    if (item.discountAllocations && item.discountAllocations.length > 0) {
        const discountTotal = (item.discountAllocations.map(e => parseFloat(e.discountedAmount?.amount || '0')).reduce((a, b) => a + b, 0))

        discountedTotal = {
            amount: (parseFloat(item.cost.subtotalAmount.amount) - discountTotal).toString(),
            currencyCode: item.cost.amountPerQuantity.currencyCode
        };

        discountedUnitPrice = {
            amount: ((parseFloat(item.cost.subtotalAmount.amount) - discountTotal) / item.quantity).toString(),
            currencyCode: item.cost.amountPerQuantity.currencyCode
        }
    }
    else {
        discountedUnitPrice = discounts.discountPriceForPrice(item.quantity, item.cost.amountPerQuantity as MoneyV2, totalQuantity || item.quantity);
        // discountedUnitPrice = discounts.discountPriceForPrice(item.quantity, item.cost.amountPerQuantity as MoneyV2);
        discountedTotal = {
            amount: (parseFloat(discountedUnitPrice.amount) * item.quantity).toString(),
            currencyCode: discountedUnitPrice.currencyCode
        };
        // discountedTotal = { amount: item.cost.subtotalAmount.amount, currencyCode: item.cost.subtotalAmount.currencyCode };
        // discountedUnitPrice = { amount: item.cost.amountPerQuantity.amount, currencyCode: item.cost.amountPerQuantity.currencyCode }
    }

    // console.log('heree item cost', { discountAllocations: item.discountAllocations, discounts, nonDiscountTotal: nonDiscountTotal.amount, discountedTotal: discountedTotal.amount, discountedUnitPrice: discountedUnitPrice.amount })

    // console.log('heree image', item.merchandise.image)

    // console.log('heree image', item.merchandise.product.media)

    return (
        <TableRow
            key={item.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell sx={styles.productImageCell}>
                {/* <ShopifyImage data={item.merchandise.image} height="100px" /> */}
                {/* <img src={item.merchandise.image.url} style={{ height: "150px" }} /> */}
                <img src={item.merchandise?.product?.media?.nodes[indexOfFirstProductImageForCart].previewImage?.url || item.merchandise.image?.url} style={{ height: "150px" }} />
            </TableCell>
            <TableCell component="th" scope="row">
                <Stack gap={1}>
                    <Stack gap={0.2}>
                        {/* <Typography variant='body1' component='div'><Button variant='text' sx={{ p: 0 }} component={Link} to={productRoute}>{antiSlugify(item.merchandise.product.productType)}</Button></Typography> */}
                        <Typography variant='body1' component='div'><Button variant='text' sx={{ p: 0 }} component={Link} to={productRoute}>{item.merchandise.product.title}</Button></Typography>
                    </Stack>
                    <Stack gap={0.2}>
                        {item.merchandise.selectedOptions?.map(i =>
                            <Typography key={i.name} variant='subtitle2' component='div'>{i.name} - {i.value}</Typography>
                        )}
                    </Stack>
                </Stack>
            </TableCell>
            <TableCell align="right" sx={styles.lineItemSubtotalCell}><MoneyDisplay money={discountedUnitPrice} quantity={1} nonDiscounted={item.cost.amountPerQuantity as MoneyV2} /></TableCell>
            <TableCell align="right">
                <NumericInput
                    id={`quantity-${item.id}`}
                    disabled={allLoading}
                    textBox={loggedInCustomer.wholesale}
                    value={item.quantity}
                    includeZero={true}
                    aria-label="Select quantity"
                    variant="outlined"
                    size="small"
                    onChange={(v) => handleQuantityChange(v)}
                />
            </TableCell>
            <TableCell align="right"><MoneyDisplay compactOnMobile money={discountedTotal} nonDiscounted={nonDiscountTotal} /></TableCell>
            {/* <TableCell align="right"><MoneyDisplay money={subtotal} /></TableCell> */}
            <TableCell align="right" sx={styles.cartDesktopActionsCell}>
                <Tooltip title="Remove">
                    <IconButton onClick={handleRemove} disabled={allLoading} aria-label={`Remove ${item.merchandise.product.title} from cart`}>
                        <Delete />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    )
}
